module.exports = __webpack_public_path__ + "static/img/战略级场景_产品图_image@2x.36790b8d.png";